module.exports = __webpack_public_path__ + "media/packs/images/flags/NL-dfa1db0dbf9d34af95c178a3ccc97c48.svg";